import { useMediaQuery } from '@mui/material'
import Box from '@mui/material/Box'
import ScrollContainer from 'Components/_common/ScrollContainer'
import { useEffect, useRef, useState } from 'react'
import { BREAKPOINT_MIN_MD } from 'Theme/stylesUtil'

import RoadmapEvent from './RoadmapEvent'

const RoadMapScroll = ({ roadMap }) => {
  const scrollContainer = useRef(null)
  const isBiggerThanMDScreen = useMediaQuery(BREAKPOINT_MIN_MD)
  const paddingBottom = isBiggerThanMDScreen ? '36px' : '0'
  const [clickableContestId, setClickableContestId] = useState(null)
  const [clickableTournamentId, setClickableTournamentId] = useState(null)

  useEffect(() => {
    if (!roadMap?.data?.length) return
    const contestId = roadMap.data.find((event) => event.contest_id && !event.is_started)?.contest_id
    const tournamentId = roadMap.data.find((event) => event.tournament_id && !event.is_started)?.tournament_id

    setClickableContestId(contestId)
    setClickableTournamentId(tournamentId)
  }, [roadMap])

  if (!roadMap?.data?.length) return null
  return (
    <Box sx={{ paddingBottom }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: '24px',
        }}
      >
        <ScrollContainer ref={scrollContainer}>
          <Box
            sx={{
              display: 'flex',
              mb: 2,
              gap: 2,
            }}
          >
            {roadMap.data.map((event, index) => (
              <RoadmapEvent
                key={index}
                clickableContestId={clickableContestId}
                clickableTournamentId={clickableTournamentId}
                event={event}
                relations={roadMap.relations}
              />
            ))}
          </Box>
        </ScrollContainer>
      </Box>
    </Box>
  )
}

export default RoadMapScroll
